import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Error404 = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                textAlign: 'center',
                background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)', // Subtle gradient for a modern look
                padding: '2rem',
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    color: '#1565c0',
                }}
            >
                404 - Lost in Cyberspace
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    marginBottom: '1.5rem',
                    color: '#424242',
                    maxWidth: '600px',
                }}
            >
                Uh-oh! We couldn’t find the page you’re looking for. Perhaps you took a wrong turn or the link is broken. But don’t worry, we’re here to guide you back!
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: '1.5rem', fontWeight: 'bold', color: '#1565c0' }}>
                Let’s get you back on track:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', alignItems: 'center' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/')}
                    sx={{
                        borderRadius: '20px',
                        padding: '0.5rem 2rem',
                        fontWeight: 'bold',
                    }}
                >
                    Take Me Home
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => navigate('/guide')}
                    sx={{
                        borderRadius: '20px',
                        padding: '0.5rem 2rem',
                        fontWeight: 'bold',
                    }}
                >
                    Explore Everyday Passwords
                </Button>
                <Button
                    variant="contained"
                    color="info"
                    onClick={() => navigate('/validate')}
                    sx={{
                        borderRadius: '20px',
                        padding: '0.5rem 2rem',
                        fontWeight: 'bold',
                    }}
                >
                    Validate Your Password
                </Button>
            </Box>
        </Box>
    );
};

export default Error404;
